var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeriferyLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.4 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6de01c;}.cls-2{fill:#00a0ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.4,12.05a2.45,2.45,0,0,0,0-.27c0-.1,0-.21,0-.31l0-.32c0-.1,0-.21,0-.31s0-.21,0-.31A12.48,12.48,0,0,0,27.1.06,12.48,12.48,0,0,0,14.15,8.25H28.7a1.54,1.54,0,0,1,.6.13,1.47,1.47,0,0,1,.48.38,1.52,1.52,0,0,1,.27.54,1.35,1.35,0,0,1,0,.6l-1.14,5.54a1.36,1.36,0,0,1-1.36,1.09H14.13a12,12,0,0,0,1.51,2.94,12.44,12.44,0,0,0,5.07,4.24,12.55,12.55,0,0,0,12.71-1.36,12.43,12.43,0,0,0,4-5.22c.05-.15.12-.29.17-.44s.07-.19.1-.29.1-.27.14-.41.08-.28.11-.42l.09-.34.06-.31c0-.1,0-.2.06-.3a2.87,2.87,0,0,0,0-.31c0-.24.07-.48.1-.72,0-.07,0-.14,0-.21s0-.4,0-.6v-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.28,24.82H1.58L0,31.42A1.4,1.4,0,0,0,0,32a1.42,1.42,0,0,0,.27.55A1.29,1.29,0,0,0,.78,33a1.38,1.38,0,0,0,.6.13H12.77l1-4.86A20,20,0,0,1,10.28,24.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.15,8.25h-8A1.36,1.36,0,0,0,4.82,9.33l-1.63,7.2H14.13a12.45,12.45,0,0,1,0-8.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriferyLogoIcon);
export default __webpack_public_path__ + "static/media/perifery-logo-icon.2c33a0fffabbc464bea81abf6f1aeabd.svg";
export { ForwardRef as ReactComponent };